import { Stack, Typography } from "@hiver/hiver-ui-kit";
import React from "react";
import SVGInline from "react-svg-inline";
const FilterHeader = ({ label, icon }) => {
  return (
    <Stack sx={{ marginBottom: "16px" }} flexDirection="row">
      <SVGInline
        svg={icon}
        style={{ marginTop: "2px" }}
        width="auto"
        height="17px"
      />
      <Typography
        variant="body2"
        sx={{
          fontWeight: "normal",
          fontStyle: "normal",
          fontStretch: "normal",
          lineHeight: "1.54",
          marginLeft: "10px",
        }}
      >
        {label}
      </Typography>
    </Stack>
  );
};

export default FilterHeader;
